import React from 'react';
import styled from '@emotion/styled';
import DesktopMacRoundedIcon from '@mui/icons-material/DesktopMacRounded';
import ScreenRotationRoundedIcon from '@mui/icons-material/ScreenRotationRounded';

const StyledMobileOverlay = styled.div`

    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(18, 42, 71, 0.95);
    color: #DDE9F7;
    backdrop-filter: blur(7px);
    transition: background-color 0.2s ease-in-out, border 0.2s ease-in-out;

    h2 {
        text-align: center;
    }
`;

const MobileOverlay = ({ platform, orientation }) => (
    <StyledMobileOverlay>
        {platform === "mobile" ? (
            <>
                <DesktopMacRoundedIcon sx={{ fontSize: "5rem" }} />
                <h2>Please visit this site on a tablet or desktop</h2>
            </>
        ) : (
            <>
                <ScreenRotationRoundedIcon sx={{ fontSize: "5rem" }} />
                <h2>Please rotate your device</h2>
            </>
        )}
    </StyledMobileOverlay>
);

export default MobileOverlay;